<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Blast Message</h3>
            </div>
            <div class="col-6 text-right">
                <button @click="showModal()" class="button primary">Send Blast</button>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="status" slot-scope="props">
                    {{props.rowData.status | MessageStatus}}
    
                </div>

                <div slot="recipients" slot-scope="props">
                    {{props.rowData.recipients | formatNumber}}
    
                </div>
    
            </vuetable>
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
    
        </div>
        <b-modal ref="blastModal" hide-footer title="Send Blast Message">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Select Blast</label>
                    <select v-model="blastName">
                            <option value>Select Blast</option>
                            <option v-for="(n,index) in blastList" :key="index+1" :value="n.text"> {{n.title}} - {{ n.value }}</option>
                        </select>
                </div>
                <div class="col-12">
                    <label>Message</label>
                    <textarea rows="10" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="message" required />
                </div>
            </div>
    
            <div class="mb-3">
                <b-button variant="outline-success" block @click="sendBlastMessage()" id="sendBTNMessage">Send Message</b-button>
            </div>
    
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../store";
import $ from "jquery";
import numeral from "numeral";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",
    data() {
        return {
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/portal/v1/sms/blast/view",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [

                {
                    name: "campaign_id",
                    title: 'Campaign ID',
                    sortField: "campaign_id",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "recipients",
                    title: 'Total Recipients',
                    sortField: "recipients",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },
                {
                    name: "status",
                    title: "Status",
                    sortField: "status",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "message",
                    title: "Message",
                    sortField: "message",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "created_at",
                    title: "Date",
                    sortField: "created_at",
                    callback: "created_at"
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "created_at",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            },

            errorcreateStatus: false,
            errorsMessage: "",
            days: 30,
            blastList: null,
            blastName: "active",
            message: ""
        };
    },
    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }
        vm.getBlastList()
    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },
    methods: {
        showModal() {
            this.$refs['blastModal'].show()
        },
        hideModal() {
            this.$refs['blastModal'].hide()
            this.$refs.vuetable.refresh();
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },
        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },
        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },
        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        },
        getBlastList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/sms/blast_groups',
                type: "get",
                async: true,
                data: {
                    "days": vm.days
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    if (response.data.code == 200) {
                        vm.blastList = response.data.data
                    } else {
                        vm.blastList = []
                    }
                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        generateUniqueId(length = 10) {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        sendBlastMessage() {
            let vm = this
            $("#sendBTNMessage").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/sms/send_group',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    shortCode: "CHEZALIGI",
                    message: vm.message,
                    blast_name: vm.blastName,
                    days: vm.days,
                    uniqueId: vm.generateUniqueId(),
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#sendBTNMessage").text("Send Message");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#sendBTNMessage").text("Send Message");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
    },
    filters: {

        MessageStatus(value) {
            if (value == 400) {
                return "Sent"
            } else {
                return "Pending"
            }
        },
        formatNumber(value) {
            return numeral(value).format("0,0");
        },

    }

};
</script>
